import * as Styles from "./styles";

export const Body = ({ children, ...rest }) => {
  return (
    <Styles.Body {...rest}>
      {
        children && children
      }
    </Styles.Body>
  );
};
